import { Provider } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { RegistrationEffects } from '../+state/registration.effects';
import * as fromRegistration from '../+state/registration.reducer';

export function provideRegistrationStore(): Provider {
  return [
    provideState(
      fromRegistration.REGISTRATION_FEATURE_KEY,
      fromRegistration.registrationReducer
    ),
    provideEffects(RegistrationEffects),
  ];
}
